import { authFeatureKey } from './lib/store/reducers/auth-reducers'

/*
 * Public API Surface of ng-client-auth
 */

export * from './lib/components/login/login.component'
export * from './lib/components/logout/logout.component'
export * from './lib/user'
export * from './lib/ng-client-auth.module'
export * from './lib/oidc-client-config'
export * from './lib/auth-interceptor.service'
export * from './lib/auth.service'
export * from './lib/authorization-guard.service'
export * from './lib/session-update.service'
export * from './lib/store/auth-model'
export * from './lib/store/selectors/auth-selectors'
export * from './lib/session-timeout.service'
export * from './lib/store/actions/auth-action-types'
export { authFeatureKey } from './lib/store/reducers/auth-reducers'
